module.exports = __webpack_public_path__ + "img/newreports-line.6b196f1e.svg";